import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const TemplateCard = ({ template, isSelected, onSelect }) => {
  return (
    <div 
      onClick={() => onSelect(template)}
      style={{
        background: isSelected ? 'var(--color-background-info)' : 'var(--color-background-primary)',
        border: `1px solid ${isSelected ? 'var(--color-brand-primary)' : 'var(--color-border-primary)'}`,
        borderRadius: '8px',
        padding: '16px',
        cursor: 'pointer',
        position: 'relative',
        transition: 'all 0.2s ease',
        boxShadow: isSelected ? '0 0 0 1px var(--color-brand-primary)' : 'none'
      }}
    >
      {isSelected && (
        <CheckCircle2 
          size={20} 
          color="var(--color-brand-primary)" 
          style={{ position: 'absolute', top: '16px', right: '16px' }} 
        />
      )}
      
      <h4 style={{ 
        fontSize: '16px', 
        fontWeight: '600', 
        marginBottom: '12px',
        color: isSelected ? 'var(--color-brand-primary)' : 'var(--color-text-primary)'
      }}>
        {template.name}
      </h4>
      
      <div style={{
        background: 'var(--color-background-secondary)',
        padding: '12px',
        borderRadius: '6px',
        fontSize: '14px',
        color: 'var(--color-text-secondary)',
        lineHeight: '1.5',
        maxHeight: '100px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}>
        {template.body || template.content || "Template preview..."}
      </div>
      
      <div style={{ marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <span style={{ 
          fontSize: '12px', 
          background: 'var(--color-background-tertiary)', 
          padding: '2px 8px', 
          borderRadius: '4px',
          color: 'var(--color-text-tertiary)'
        }}>
          {template.category || 'MARKETING'}
        </span>
        <span style={{ 
          fontSize: '12px', 
          background: 'var(--color-background-tertiary)', 
          padding: '2px 8px', 
          borderRadius: '4px',
          color: 'var(--color-text-tertiary)'
        }}>
          {template.language || 'en'}
        </span>
      </div>
    </div>
  );
};

export default TemplateCard;
